export default __webpack_public_path__ + "static/testimonialHolder1-5049eac3f75a06d61de087e164453391.png";